import { createFileRoute } from '@tanstack/react-router'
import { JobsPlayground } from '@/features/admin/jobs-playground'

type SearchParams = {
  searchId?: string
  tab?: string
}

export const Route = createFileRoute('/_authenticated/admin/jobs-playground')({
  component: JobsPlayground,
  validateSearch: (search: Record<string, unknown>): SearchParams => ({
    searchId: (search.searchId as string) || undefined,
    tab: (search.tab as string) || undefined,
  }),
})
